import { Link } from 'react-router-dom';
import { Twitter, MessageCircle, Youtube } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black text-white">
      <div className="container px-4 md:px-6 py-6 md:py-8">
        {/* Mobile layout - brand centered, then grid */}
        <div className="flex flex-col items-center space-y-6 md:hidden">
          {/* Brand and tagline */}
          <div className="text-center space-y-1">
            <Link to="/" className="block">
              <span className="text-xl font-bold">Talktrail</span>
            </Link>
            <p className="text-sm text-zinc-400">
              A place to read, write, and connect with great thinkers.
            </p>
          </div>

          {/* Grid layout for social and links */}
          <div className="grid grid-cols-2 gap-4 w-full max-w-sm">
            {/* Left side - Social media in 2x2 grid */}
            <div className="flex justify-center">
              <div className="grid grid-cols-2 gap-1">
                <a
                  href="https://x.com/tracverse"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
                >
                  <Twitter className="h-4 w-4" aria-hidden="true" />
                  <span className="sr-only">Follow us on Twitter</span>
                </a>
                <a
                  href="https://t.me/tracverse"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
                >
                  <svg
                    className="h-4 w-4"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
                  </svg>
                  <span className="sr-only">Join us on Telegram</span>
                </a>
                <a
                  href="https://discord.gg/tracverse"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
                >
                  <MessageCircle className="h-4 w-4" aria-hidden="true" />
                  <span className="sr-only">Join our Discord server</span>
                </a>
                <a
                  href="https://youtube.com/@tracverse"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
                >
                  <Youtube className="h-4 w-4" aria-hidden="true" />
                  <span className="sr-only">
                    Subscribe to our YouTube channel
                  </span>
                </a>
              </div>
            </div>

            {/* Right side - Links */}
            <div className="flex flex-col items-center space-y-3 text-center">
              <Link
                to="/terms"
                className="text-zinc-400 hover:text-white text-sm"
              >
                Terms of Service
              </Link>
              <Link
                to="/privacy"
                className="text-zinc-400 hover:text-white text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/cookies"
                className="text-zinc-400 hover:text-white text-sm"
              >
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>

        {/* Desktop layout - horizontal */}
        <div className="hidden md:flex justify-between items-center">
          {/* Left side - Brand and tagline stacked */}
          <div className="space-y-1">
            <Link to="/" className="block">
              <span className="text-xl font-bold">Talktrail</span>
            </Link>
            <p className="text-sm text-zinc-400">
              A place to read, write, and connect with great thinkers.
            </p>
          </div>

          {/* Center - Social media */}
          <div className="flex justify-center gap-2">
            <a
              href="https://x.com/tracverse"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
            >
              <Twitter className="h-4 w-4" aria-hidden="true" />
              <span className="sr-only">Follow us on Twitter</span>
            </a>
            <a
              href="https://t.me/tracverse"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
            >
              <svg
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
              </svg>
              <span className="sr-only">Join us on Telegram</span>
            </a>
            <a
              href="https://discord.gg/tracverse"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
            >
              <MessageCircle className="h-4 w-4" aria-hidden="true" />
              <span className="sr-only">Join our Discord server</span>
            </a>
            <a
              href="https://youtube.com/@tracverse"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center text-white hover:bg-white/10 h-10 w-10 rounded-md"
            >
              <Youtube className="h-4 w-4" aria-hidden="true" />
              <span className="sr-only">Subscribe to our YouTube channel</span>
            </a>
          </div>

          {/* Right side - Links */}
          <div className="flex gap-4">
            <Link
              to="/terms"
              className="text-zinc-400 hover:text-white text-sm"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              className="text-zinc-400 hover:text-white text-sm"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookies"
              className="text-zinc-400 hover:text-white text-sm"
            >
              Cookie Policy
            </Link>
          </div>
        </div>

        {/* Bottom copyright */}
        <div className="mt-6 md:mt-8 border-t border-white/10 pt-4 md:pt-6 text-center text-sm text-zinc-400">
          © {new Date().getFullYear()} Talktrail. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
